<template>
    <div class="dr_detail_wrap">
      <div class="dr_detail_title">
        {{ $t('request_detail') }}
      </div>
        <detection-detail-component :detection-type="'requestDetail'" :detectionKey="detectionKey"></detection-detail-component>
    </div>
</template>

<script>


import DetectionDetailComponent from "../../components/detection/DetectionDetailComponent";

export default {
    name: "DetectionRequestDetail",
    mixins: [],
    components: {DetectionDetailComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            detectionKey: Number(this.$route.params.idx),
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
